import { SHIFT } from "./types";

import ActionHelper from "../helpers/ActionHelper";
import moment from "moment";

export const createShift = (form) => () => {
  return ActionHelper.requestServer("POST", `/shift`, form);
};

export const getShiftsByProjectId = (projectId) => (dispatch) => {
  return ActionHelper.requestServer(
    "GET",
    `/project/${projectId}/shift`,
    null,
    SHIFT.SHIFT_GET_SHIFTS_REQUEST,
    SHIFT.SHIFT_GET_SHIFTS_SUCCESS,
    SHIFT.SHIFT_GET_SHIFTS_FAIL,
    dispatch,
  );
};

export const getShift = (shiftId) => (dispatch) => {
  return ActionHelper.requestServer(
    "GET",
    `/shift/${shiftId}`,
    null,
    SHIFT.SHIFT_GET_SHIFT_REQUEST,
    SHIFT.SHIFT_GET_SHIFT_SUCCESS,
    SHIFT.SHIFT_GET_SHIFT_FAIL,
    dispatch,
  );
};

export const updateShift = (shiftId, form) => () => {
  return ActionHelper.requestServer("PUT", `/shift/${shiftId}`, form);
};

export const deleteShift = (shiftId) => (dispatch) => {
  return ActionHelper.requestServer(
    "DELETE",
    `/shift/${shiftId}`,
    null,
    SHIFT.SHIFT_DELETE_REQUEST,
    SHIFT.SHIFT_DELETE_SUCCESS,
    SHIFT.SHIFT_DELETE_FAIL,
    dispatch,
  );
};

export const getActiveShifts = (params) => (dispatch) => {
  let urlParams = "";

  Object.keys(params).map((key) => {
    if (moment.isMoment(params[key]))
      urlParams += `${key}=${params[key].toISOString()}&`;
    else if (params[key]) urlParams += `${key}=${params[key]}&`;
  });

  return ActionHelper.requestServer(
    "GET",
    `/shift/active?${urlParams}`,
    null,
    SHIFT.SHIFT_GET_ACTIVE_SHIFTS_REQUEST,
    SHIFT.SHIFT_GET_ACTIVE_SHIFTS_SUCCESS,
    SHIFT.SHIFT_GET_ACTIVE_SHIFTS_FAIL,
    dispatch,
  );
};

export const getActiveShift = (shiftId) => (dispatch) => {
  return ActionHelper.requestServer(
    "GET",
    `/shift/active/${shiftId}`,
    null,
    SHIFT.SHIFT_GET_ACTIVE_SHIFT_REQUEST,
    SHIFT.SHIFT_GET_ACTIVE_SHIFT_SUCCESS,
    SHIFT.SHIFT_GET_ACTIVE_SHIFT_FAIL,
    dispatch,
  );
};

export const assignEmployeestoShift = (shiftId, form) => (dispatch) => {
  return ActionHelper.requestServer(
    "POST",
    `/shift/${shiftId}/employee`,
    form,
    SHIFT.SHIFT_ASSIGN_EMPLOYEES_REQUEST,
    SHIFT.SHIFT_ASSIGN_EMPLOYEES_SUCCESS,
    SHIFT.SHIFT_ASSIGN_EMPLOYEES_FAIL,
    dispatch,
  );
};

export const getEmployeesOfShift = (shiftId) => {
  return ActionHelper.requestServer("GET", `/shift/${shiftId}/employee`);
};

export const getEmployeesOfShiftByCompany =
  (shiftId, companyEmail) => (dispatch) => {
    return ActionHelper.requestServer(
      "GET",
      `/shift/${shiftId}/company/${companyEmail}/employee`,
      null,
      SHIFT.SHIFT_GET_EMPLOYEES_OF_COMPANY_REQUEST,
      SHIFT.SHIFT_GET_EMPLOYEES_OF_COMPANY_SUCCESS,
      SHIFT.SHIFT_GET_EMPLOYEES_OF_COMPANY_FAIL,
      dispatch,
    );
  };

export const removeEmployeeFromShift = (shiftId, companyEmployeeId) => {
  return ActionHelper.requestServer(
    "DELETE",
    `/shift/${shiftId}/employee/${companyEmployeeId}`,
  );
};

export const duplicateShift = (shiftId, form) => (dispatch) => {
  const { datetimes, includeEmployees } = form;
  const body = {
    datetimes: datetimes.map((d) => ({
      beginDatetime: d.beginDatetime.toISOString(),
      endDatetime: d.endDatetime.toISOString(),
    })),
    includeEmployees,
  };
  return ActionHelper.requestServer(
    "POST",
    `/shift/${shiftId}/duplicate`,
    body,
    SHIFT.SHIFT_DUPLICATE_REQUEST,
    SHIFT.SHIFT_DUPLICATE_SUCCESS,
    SHIFT.SHIFT_DUPLICATE_FAIL,
    dispatch,
  );
};

export const getFilesOfShift = (shiftId) =>
  ActionHelper.requestServer("GET", `/shift/${shiftId}/files`);



// WEBPACK FOOTER //
// ./src/actions/shiftActions.js